module.exports = __webpack_public_path__ + "public/img/icon-location.1edc4ae4.png";